import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;

import { action, computed, makeObservable, observable, runInAction } from "mobx";
import { persist } from "mobx-persist";
import BrandRules from "../../utils/BrandRules";
var DineInOrderModel = (_class = /*#__PURE__*/function () {
  function DineInOrderModel(platformUtil) {
    var _this = this;

    _classCallCheck(this, DineInOrderModel);

    _initializerDefineProperty(this, "_restaurantDetails", _descriptor, this);

    _initializerDefineProperty(this, "_sessionDetails", _descriptor2, this);

    _initializerDefineProperty(this, "_appAttributes", _descriptor3, this);

    _initializerDefineProperty(this, "_isSwitchFromDineInMessageVisible", _descriptor4, this);

    _initializerDefineProperty(this, "_isCartDetailsOpen", _descriptor5, this);

    _initializerDefineProperty(this, "_isCheckoutPageLoading", _descriptor6, this);

    _initializerDefineProperty(this, "_specialInstructions", _descriptor7, this);

    _initializerDefineProperty(this, "_splOffer", _descriptor8, this);

    _initializerDefineProperty(this, "_isOrderSubmitting", _descriptor9, this);

    _defineProperty(this, "setSwitchFromDineInMessageVisibility", function (modalState) {
      runInAction(function () {
        _this._isSwitchFromDineInMessageVisible = modalState;
      });
    });

    _defineProperty(this, "setIsCartDetailsOpen", function (modalState) {
      runInAction(function () {
        _this._isCartDetailsOpen = modalState;
      });
    });

    makeObservable(this);
  }

  _createClass(DineInOrderModel, [{
    key: "setAppAttributesData",
    value: function setAppAttributesData(_appAttributes) {
      var _this2 = this;

      runInAction(function () {
        _this2._appAttributes = _appAttributes;
      });
    }
  }, {
    key: "setSessionDetailsData",
    value: function setSessionDetailsData(_sessionDetails) {
      var _this3 = this;

      runInAction(function () {
        _this3._sessionDetails = _sessionDetails;
      });
    }
  }, {
    key: "setRestaurantDetailData",
    value: function setRestaurantDetailData(restaurantDetails) {
      var _this4 = this;

      runInAction(function () {
        _this4._restaurantDetails = restaurantDetails;
      });
    }
  }, {
    key: "formatPriceBrandWise",
    value: function formatPriceBrandWise(ItemPrice) {
      var _BrandRules, _this$_appAttributes;

      var itemPricingFormat = (_BrandRules = new BrandRules((_this$_appAttributes = this._appAttributes) === null || _this$_appAttributes === void 0 ? void 0 : _this$_appAttributes.currentConceptCode)) === null || _BrandRules === void 0 ? void 0 : _BrandRules.pricingFormat();

      switch (itemPricingFormat) {
        case "$xx":
          return "$".concat(ItemPrice.toFixed(0));

        case "$xx.xx":
          return "$".concat(ItemPrice.toFixed(2));

        case "xx":
          return "".concat(ItemPrice.toFixed(0));

        case "xx.xx":
          return "".concat(ItemPrice.toFixed(2));

        case "s52":
          return "".concat(Number(ItemPrice.toFixed(2)));

        default:
          return "$".concat(ItemPrice.toFixed(2));
      }
    }
  }, {
    key: "getFormattedPrice",
    value: function getFormattedPrice(number) {
      var result;
      if (!number) return;

      if (typeof number === "string") {
        if (number.length <= 0) return "";
        var res = number.replace(/[^\d.]/g, "");
        var b = number.replace(/[\d.]/g, "").replace("$", "");
        result = b + this.formatPriceBrandWise(Number(res));
      } else {
        result = this.formatPriceBrandWise(number);
      }

      return result.toString();
    }
  }, {
    key: "setSplOffer",
    value: function setSplOffer(val) {
      var _this5 = this;

      runInAction(function () {
        _this5._splOffer = val;
      });
    }
  }, {
    key: "isSwitchFromDineInMessageVisible",
    get: function get() {
      return this._isSwitchFromDineInMessageVisible;
    }
  }, {
    key: "isCartDetailsOpen",
    get: function get() {
      return this._isCartDetailsOpen;
    }
  }, {
    key: "specialInstructions",
    get: function get() {
      return this._specialInstructions;
    },
    set: function set(_specialInstructions) {
      var _this6 = this;

      runInAction(function () {
        _this6._specialInstructions = _specialInstructions;
      });
    }
  }, {
    key: "orderAheadOrderDescEnabled",
    get: function get() {
      var _this$_appAttributes2;

      return (_this$_appAttributes2 = this._appAttributes) === null || _this$_appAttributes2 === void 0 ? void 0 : _this$_appAttributes2.orderAheadOrderDescEnabled;
    }
  }, {
    key: "isCheckoutPageLoading",
    set: function set(_isCheckoutPageLoading) {
      var _this7 = this;

      runInAction(function () {
        _this7._isCheckoutPageLoading = _isCheckoutPageLoading;
      });
    },
    get: function get() {
      return this._isCheckoutPageLoading;
    }
  }, {
    key: "isOrderSubmitting",
    set: function set(_isOrderSubmitting) {
      var _this8 = this;

      runInAction(function () {
        _this8._isOrderSubmitting = _isOrderSubmitting;
      });
    },
    get: function get() {
      return this._isOrderSubmitting;
    }
  }, {
    key: "splOffer",
    get: function get() {
      return this._splOffer;
    }
  }]);

  return DineInOrderModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_restaurantDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_sessionDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_isSwitchFromDineInMessageVisible", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_isCartDetailsOpen", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_isCheckoutPageLoading", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_specialInstructions", [persist, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "_splOffer", [persist, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "_isOrderSubmitting", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "isSwitchFromDineInMessageVisible", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isSwitchFromDineInMessageVisible"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCartDetailsOpen", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCartDetailsOpen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "specialInstructions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "specialInstructions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "orderAheadOrderDescEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderAheadOrderDescEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCheckoutPageLoading", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCheckoutPageLoading"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "formatPriceBrandWise", [action], Object.getOwnPropertyDescriptor(_class.prototype, "formatPriceBrandWise"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "splOffer", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "splOffer"), _class.prototype)), _class);
export { DineInOrderModel as default };